export const getHostDomain = (mode: any) => {
    return  mode === 'development' ? "http://localhost:3001" : window.location.origin;
};

export default getHostDomain;